// extracted by mini-css-extract-plugin
export default {"container":"GroupAcceptQRScan_container__JqWDS","result":"GroupAcceptQRScan_result__Gg9m+"};